export const UserActionType = Object.freeze({
    SET_USER_DATA: 'Authorization:: Edit user data',
    SET_USERS: 'Users:: Set all users data',
    SET_TAB: 'UserPanel:: Set Tab',
    SET_BREAK_DOWN: 'UserPanel:: Set breakdown',
    CLOSE_DIALOG: 'Users:: Close edit user dialog box',
    OPEN_DIALOG: 'Users:: Open edit user dialog box',
    CLOSE_CREATE_DIALOG: 'Users:: Close create user dialog box',
    OPEN_CREATE_DIALOG: 'Users:: Open create user dialog box',
    SET_INVITE_TYPE: 'Users:: On set type of the invite dialog',
    SET_INVITE_LINK: 'Users:: Set Invite link',
    SET_ORDER_BY: 'User Table:: Set Order by field',
    SET_PAGING_OPT: 'User Table:: Set Pagination options',
    SET_FILTER: 'User Table:: Set Filter',
    SET_SEARCH_TEXT: 'User Table :: Set Search Text',
    SET_PAGE_OFFSET: 'User Table :: Set Offset of the user table query',
    SET_CONFIRMATION_DIALOG: 'User Table:: Delete confirmation Dialog',
    SET_CREATE_USER: 'Create User Dialog:: Create user data set',
    SET_EXISTING_GROUPS: 'Groups:: Set existing groups data',
})

export const UserRole = Object.freeze({
    USER: 'USER',
    ADMIN: 'ADMIN',
})

export const UserRoleText = Object.freeze({
    USER: 'User',
    ADMIN: 'Admin',
})

export const InviteType = Object.freeze({
    EMAIL: 'Email',
    LINK: 'Link',
    CREATE: 'Create',
})

export const USER_PROP = Object.freeze({
    ID: 'id',
    EMAIL: 'email',
    FNAME: 'firstname',
    LNAME: 'lastname',
    ROLE: 'role',
    PASSWORD: 'password',
    SEARCH: 'search',
    ABOUT: 'about',
    COUNTRY: 'country',
    APPROVAL_EMAIL: 'receive_new_user_approval_email',
    REQUIRE_2FA: 'require_2fa',
    PROVISIONING_URI: 'provisioning_uri',
    GROUPS: 'groups',
    AFFILIATION: 'affiliation',
    CREATED_AT: 'created_at',
    TITLE: 'title',
})

export const UILabels = {
    [USER_PROP.EMAIL]: 'Email',
    [USER_PROP.FNAME]: 'First Name',
    [USER_PROP.LNAME]: 'Last Name',
    [USER_PROP.PASSWORD]: 'Password',
    [USER_PROP.ROLE]: 'Role',
    [USER_PROP.AFFILIATION]: 'Affiliation',
    [USER_PROP.TITLE]: 'Title',
}

export const USER_COLUMNS = Object.freeze([
    { field: USER_PROP.ID, headerName: 'ID' },
    { field: USER_PROP.EMAIL, headerName: 'Email' },
    { field: USER_PROP.FNAME, headerName: 'First Name' },
    { field: USER_PROP.LNAME, headerName: 'Last Name' },
    { field: USER_PROP.ROLE, headerName: 'Role name' },
    {
        field: USER_PROP.REQUIRE_2FA,
        headerName: 'Enable Two Factor Authentication',
    },
])

export const USER_COLUMNS_ENHANCED = Object.freeze([
    {
        id: USER_PROP.FNAME,
        label: 'Name',
        numeric: false,
        disablePadding: false,
    },
    {
        id: USER_PROP.EMAIL,
        label: 'Email',
        numeric: false,
        disablePadding: false,
    },
    {
        id: USER_PROP.ROLE,
        label: 'Role',
        numeric: false,
        disablePadding: false,
    },
    {
        id: USER_PROP.AFFILIATION,
        label: 'Affiliation',
        numeric: false,
        disablePadding: false,
    },
    {
        id: USER_PROP.TITLE,
        label: 'Title',
        numeric: false,
        disablePadding: false,
    },
    {
        id: USER_PROP.CREATED_AT,
        label: 'Created At',
        numeric: false,
        disablePadding: false,
    },
])

export const TABS = Object.freeze({
    MEMBER_TAB: 'members',
    APPROVAL_TAB: 'pending_approval',
    INACTIVE_USERS_TAB: 'inactive',
})

export const ChangeRequestStatus = Object.freeze({
    PENDING: 1,
    APPROVED: 2,
    DENIED: 3,
})

export const ChangeRequestStatusText = Object.freeze({
    PENDING: 'Pending',
    APPROVED: 'Approved',
    DENIED: 'Denied',
})

export const ChangeRequestType = Object.freeze({
    APPROVE_USER: 'APPROVE_USER',
    ROLE_CHANGE: 'ROLE_CHANGE',
})

export const ChangeRequestTypeText = Object.freeze({
    APPROVE_USER: 'User Approval',
    ROLE_CHANGE: 'Role Changes',
})
